import {AGREE_DECLINE} from '../action-creators/display-details';
import {AGREE} from '../action-creators/display-details';
import {AGREE_LINK} from '../action-creators/display-details';


const displayDetailsReducer = (state = {checked:false},action) => {
     console.log(action.type)
        switch(action.type){
            case AGREE_DECLINE:
               console.log(`${AGREE_DECLINE} reducerss state:${JSON.stringify(state)} payload:${JSON.stringify(action.payload)}`);
                return action.payload;  
           case AGREE:
                console.log(`${AGREE} reducerss state:${JSON.stringify(state)} payload:${JSON.stringify(action.payload)}`);
                 return action.payload;  
           case AGREE_LINK:
                 console.log(`${AGREE_LINK} reducerss state:${JSON.stringify(state)} payload:${JSON.stringify(action.payload)}`);
                 return action.payload;                             
            default:
                console.log(`${AGREE_DECLINE} reducer state:${JSON.stringify(state)}`);
                return state;          
           }
   }
export default displayDetailsReducer;